<template>
	<div class="detail-form">
		<div class="detail-form__img" v-if="!isLoadingOriginators">
			<div class="detail-form__img-file">
				<input
					class="detail-form__img-file__input"
					type="file"
					id="logo_avatar"
					@change="onFileChange"
				/>
				<img class="detail-form__img-file__logo" :src="imgSrc" alt="" v-if="imgSrc" />
				<EmptyImg v-else />
			</div>
			<label class="detail-form__img-action" for="logo_avatar">
				{{ imgSrc ? 'Trocar Foto' : 'Adicionar Foto' }}
			</label>
		</div>
		<div>
			<div class="row" v-show="!isLoadingOriginators">
				<div class="detail-form__field" :ref="'nameRequired'">
					<label class="detail-form__field--label" for="name">Nome do Originador: *</label>
					<input
						class="detail-form__field--input"
						:class="[requiredFields.name ? 'alert' : '']"
						id="name"
						type="text"
						placeholder="Nome do Originador"
						v-model="originator.name"
					/>
					<small class="detail-form__field--input--required" v-if="requiredFields.name">
						Campo obrigatório.
					</small>
				</div>
				<div class="detail-form__field">
					<label class="detail-form__field--label" for="corporate_name">Codinome:</label>
					<input
						class="detail-form__field--input"
						id="corporate_name"
						type="text"
						placeholder="Codinome"
						v-model="originator.corporate_name"
					/>
				</div>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<div class="detail-form__field">
					<label class="detail-form__field--label" for="cnpj">CNPJ:</label>
					<input
						class="detail-form__field--input"
						:class="[requiredFields.cnpj ? 'alert' : '']"
						id="cnpj"
						type="text"
						placeholder="00.000.000/0000-00"
						v-mask="'##.###.###/####-##'"
						v-model="originator.cnpj"
					/>
					<small class="detail-form__field--input--required" v-if="requiredFields.cnpj">
						Campo obrigatório.
					</small>
				</div>
				<div class="detail-form__field" :ref="'statusRequired'">
					<label class="detail-form__field--label" for="status">Status: *</label>
					<GenericMultiselect
						class="detail-form__field--input"
						:alertClass="requiredFields.statusId"
						ref="status"
						:options="statusOptions"
						:placeholder="'Selecionar Status'"
						:fullWidth="!isWeb"
						:searchable="false"
						:clearOnOpen="false"
						:needType="true"
						:type="'status'"
						@changeInput="changeStatusInput"
					/>
					<small class="detail-form__field--input--required" v-if="requiredFields.statusId">
						Campo obrigatório.
					</small>
				</div>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<InputGroup
					:title="'Descrição:'"
					:customClass="'textarea'"
					:id="'description'"
					:placeholder="'Mensagem'"
					:maxLength="189"
					:isTextArea="true"
					v-model="originator.shortDescription"
				/>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<InputGroup
					:title="'Descrição Longa:'"
					:customClass="'textarea long'"
					:id="'long_description'"
					:placeholder="'Mensagem'"
					:isTextArea="true"
					v-model="originator.description"
				/>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<div class="detail-form__field">
					<label class="detail-form__field--label" for="location">Local da Sede:</label>
					<input
						class="detail-form__field--input"
						id="location"
						type="text"
						placeholder="Inserir Local"
						v-model="originator.headOfficeLocation"
					/>
				</div>
				<div class="detail-form__field" :ref="'industryRequired'">
					<label class="detail-form__field--label" for="industry">Indústria: *</label>
					<GenericMultiselect
						class="detail-form__field--input"
						:alertClass="requiredFields.industryTypeId"
						ref="industry"
						:options="industriesOptions"
						:placeholder="'Selecionar Indústria'"
						:fullWidth="!isWeb"
						:searchable="true"
						:clearOnOpen="false"
						:needType="true"
						:type="'industry'"
						@changeInput="changeIndustryInput"
					/>
					<small class="detail-form__field--input--required" v-if="requiredFields.industryTypeId">
						Campo obrigatório.
					</small>
				</div>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<InputGroup
					:title="'Data de Fundação:'"
					:id="'foundation'"
					:placeholder="'__/____'"
					:isMasked="'##/####'"
					v-model="originator.foundationDate"
				/>
				<InputGroup
					:title="'Apresentação Institucional'"
					:id="'advertising_material'"
					:ref="'advertising_material'"
					:placeholder="'Apresentação Institucional.pdf'"
					:isFile="true"
					:isTeaser="true"
					@clearTeaser="clearAdvertising"
					v-model="originator.advertisingMaterialUrl"
				/>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<InputGroup
					:title="'Site:'"
					:customClass="'full'"
					:id="'site'"
					:placeholder="'https://www.sitedooriginador.com.br'"
					:isLink="true"
					v-model="originator.site"
				/>
			</div>
			<div class="row" v-show="!isLoadingOriginators">
				<InputGroup
					:title="'Vídeo'"
					:id="'originator_video'"
					:placeholder="'https://www.youtube.com/videodooriginador'"
					:isLink="true"
					v-model="originator.videoUrl"
				/>
				<div class="detail-form__field">
					<label class="detail-form__field--label" for="status">Tipo de Vídeo:</label>
					<GenericMultiselect
						class="detail-form__field--input"
						ref="video_type"
						:options="videoOptions"
						:placeholder="'Tipo de Vídeo'"
						:fullWidth="!isWeb"
						:searchable="false"
						:clearOnOpen="false"
						:needType="true"
						:type="'videoType'"
						@changeInput="changeVideoInput"
					/>
				</div>
			</div>
			<div class="row" v-show="!isLoadingOriginators" v-if="!newOriginator">
				<InputGroup
					:title="'Valor total de todas as ofertas finalizadas:'"
					:isMoney="true"
					:id="'value_total'"
					:ref="'value_total'"
					:placeholder="''"
					:isDisabled="true"
				/>
				<InputGroup
					:title="'Prazo da última emissão:'"
					:id="'deadlineLastEmissions'"
					:placeholder="''"
					v-model="originator.deadlineLastEmissions"
					:isDisabled="true"
				/>
			</div>
			<div class="row" v-show="!isLoadingOriginators" v-if="!newOriginator">
				<InputGroup
					:title="'Remuneração da última emissão:'"
					:id="'remunerationLastEmissions'"
					:placeholder="''"
					v-model="originator.remunerationLastEmissions"
					:isDisabled="true"
				/>
				<InputGroup
					:title="'Número de emissões (somente fechadas):'"
					:id="'numberEmissions'"
					:placeholder="''"
					v-model="originator.numberEmissions"
					:isDisabled="true"
				/>
			</div>
			<div class="detail-form__docs" v-show="!isLoadingOriginators">
				<div class="detail-form__docs-title">
					<h1 class="detail-form__docs-title--text">Documentos do Originador</h1>
					<span class="detail-form__docs-title--icon" @click="addNewDocs()">
						<PlusIconVariant />
					</span>
				</div>
				<draggable
					class="drag-list"
					v-bind="dragOptions"
					:list="originator.originatorDocs"
					v-if="originator.originatorDocs.length"
				>
					<div
						class="detail-form__docs-form"
						v-for="(doc, index) in originator.originatorDocs"
						:key="index"
					>
						<div class="row">
							<div class="detail-form__docs-form--move">
								<MoveIcon />
							</div>
							<div class="detail-form__docs-form--input w-100">
								<InputGroup
									:title="'Nome do Documento'"
									:customClass="'full'"
									:id="`docs_name_${index + 1}`"
									:placeholder="'Nome do Documento'"
									v-model="doc.name"
								/>
							</div>
							<div class="detail-form__docs-form--input w-100">
								<InputGroup
									:title="'Upload de Arquivo'"
									:customClass="'full'"
									:id="`docs_file_${index + 1}`"
									:ref="`docs_file_${index + 1}`"
									:placeholder="'Upload de Arquivo'"
									:isFile="true"
									v-model="doc.docUrl"
								/>
							</div>
						</div>
						<div class="row">
							<div class="detail-form__field w-100 docs ml-1">
								<label class="detail-form__field--label" :for="`doc_type_${index + 1}`">
									Tipo de Documento:
								</label>
								<GenericMultiselect
									class="detail-form__field--input"
									:ref="`doc_type_${index + 1}`"
									:options="docTypeOptions"
									:placeholder="'Tipo de Documento'"
									:fullWidth="!isWeb"
									:searchable="true"
									:clearOnOpen="false"
									:needType="true"
									:type="`doc_type_${index + 1}`"
									@changeInput="changeTypeInput"
								/>
							</div>
							<div class="detail-form__field w-100 docs ml-2">
								<label class="detail-form__field--label" :for="`doc_subtype_${index + 1}`">
									Subtipo de Documento:
								</label>
								<GenericMultiselect
									class="detail-form__field--input"
									:ref="`doc_subtype_${index + 1}`"
									:options="docSubtypeOptions"
									:placeholder="'Subtipo de Documento'"
									:fullWidth="!isWeb"
									:searchable="true"
									:clearOnOpen="false"
									:needType="true"
									:type="`doc_subtype_${index + 1}`"
									@changeInput="changeSubtypeInput"
								/>
							</div>
						</div>
						<div class="detail-form__docs-form--delete" @click="removeDocs(doc)">
							<span>Excluir Documento</span>
						</div>
					</div>
				</draggable>
			</div>
			<div class="detail-form__docs" v-show="!isLoadingOriginators">
				<div class="detail-form__docs-title">
					<h1 class="detail-form__docs-title--text">Redes Sociais</h1>
					<span
						class="detail-form__docs-title--icon"
						@click="addNewSocialMedia()"
						v-show="addSocials <= 5"
					>
						<PlusIconVariant />
					</span>
				</div>
				<draggable
					class="drag-list"
					v-bind="dragOptions"
					:list="originator.socialMedia"
					v-if="originator.socialMedia.length"
				>
					<div
						class="detail-form__docs-form"
						v-for="(doc, index) in originator.socialMedia"
						:key="index"
					>
						<div class="row">
							<div class="detail-form__docs-form--move">
								<MoveIcon />
							</div>
							<div class="detail-form__field w-100 docs ml-2">
								<label class="detail-form__field--label" :for="`doc_type_${index + 1}`">
									Rede social:
								</label>
								<GenericMultiselect
									class="detail-form__field--input"
									:ref="`social_media_${index + 1}`"
									:options="currentSocialMediaOptions"
									:placeholder="'Rede social'"
									:fullWidth="!isWeb"
									:searchable="true"
									:clearOnOpen="false"
									:needType="true"
									:type="`social_media_${index + 1}`"
									@changeInput="changeSocialMediaInput"
								/>
							</div>
							<div class="detail-form__docs-form--input w-100">
								<InputGroup
									:title="'Url da rede social'"
									:customClass="'full'"
									:id="`social_media_url_${index + 1}`"
									:placeholder="'Url da rede social'"
									v-model="originator.socialMedia[index].url"
								/>
							</div>
						</div>
						<div class="detail-form__docs-form--delete" @click="removeSocialMedia(doc)">
							<span>Excluir Rede Social</span>
						</div>
					</div>
				</draggable>
			</div>
			<div class="mt-25" v-show="!isLoadingOriginators">
				<div class="detail-form__docs-title">
					<h1 class="detail-form__docs-title--text mb-5">Personalizar permissões</h1>
				</div>
				<div class="rowTypeCheckbox">
					<div v-for="(element, index) in dashboardsTabs" :key="index">
						<label class="checkbox-field"
							>{{ element.label }}
							<input type="checkbox" v-model="element.checked" />
							<span class="checkmark"></span>
						</label>
					</div>
				</div>
			</div>
			<div class="mt-25" v-show="!isLoadingOriginators">
				<div class="detail-form__docs-title">
					<h1 class="detail-form__docs-title--text mb-5">Personalizar Dashboard</h1>
				</div>
				<div class="row mt-10">
					<div class="detail-form__field" ref="defaultWalletRequired">
						<label class="detail-form__field--label" for="defaultWallet">Carteira Default: *</label>
						<GenericMultiselect
							class="detail-form__field--input"
							:alertClass="requiredFields.defaultWallet"
							ref="defaultWallet"
							:options="walletOptions"
							placeholder="Selecione a Carteira Default"
							:fullWidth="!isWeb"
							:searchable="false"
							:clearOnOpen="false"
							:needType="true"
							type="defaultWallet"
							:disabled="!isEditing"
							@changeInput="changeDefaultWallet"
						/>
						<small class="detail-form__field--input--required" v-if="requiredFields.defaultWallet">
							Campo obrigatório.
						</small>
					</div>
				</div>
			</div>
			<div
				class="detail-form__actions"
				:class="newOriginator ? 'new-user' : ''"
				v-show="!isLoadingOriginators"
			>
				<button
					class="detail-form__actions--btn outline"
					@click="handleDeleteModal()"
					v-if="!newOriginator"
				>
					Excluir Originador
				</button>
				<div class="detail-mobile">
					<button
						class="detail-form__actions--btn variant"
						@click="goToCreateOffer()"
						v-if="!newOriginator"
					>
						Criar Oferta
						<div class="icon-btn">
							<SidebarArrow :background="'#0047FF'" :border="'#fff'" :size="15" />
						</div>
					</button>
					<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
				</div>
			</div>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingOriginators">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Originador'"
			:subtitle="'Tem certeza que deseja excluir este Originador?'"
			:loader="isLoadingOriginators"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_ORIGINATOR_BY_ID,
	CREATE_ORIGINATOR,
	UPDATE_ORIGINATOR,
	DELETE_ORIGINATOR,
	GET_ALL_INDUSTRY,
	GET_ALL_DOC_TYPE,
	GET_ALL_DOC_SUBTYPE,
} from '@/store/modules/originatorManagement/actions';
import { GET_ALL_ORIGINATORS } from '@/store/modules/offerManagement/actions';
import { mask } from 'vue-the-mask';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import EmptyImg from '@/components/shared/Icons/EmptyImg.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import PlusIconVariant from '@/components/shared/Icons/PlusIconVariant.vue';
import MoveIcon from '@/components/shared/Icons/MoveIcon.vue';
import draggable from 'vuedraggable';
import { scrollToRequiredElement } from '@/utils/scrollToRequiredElement';
import { removeSpecialChars } from '@/utils/stringHelper';
import { copyAndRenameFile } from '@/utils/fileHelper';
import OfferStatusEnum from '@/enums/OfferStatusEnum';

export default {
	name: 'OriginatorForm',
	directives: { mask },
	components: {
		GenericMultiselect,
		SpinnerIcon,
		EmptyImg,
		DeleteModal,
		SidebarArrow,
		InputGroup,
		PlusIconVariant,
		MoveIcon,
		draggable,
	},
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		originator: {
			name: '',
			corporate_name: '',
			cnpj: '',
			description: '',
			shortDescription: null,
			statusId: '',
			industryTypeId: '',
			videoUrl: null,
			videoType: null,
			defaultWallet: null,
			hasFullWallet: null,
			logoFile: '',
			headOfficeLocation: '',
			site: '',
			foundationDate: '',
			totalValueOffer: '',
			deadlineLastEmissions: '',
			remunerationLastEmissions: '',
			numberEmissions: '',
			advertisingMaterialUrl: null,
			originatorDocs: [
				{
					name: null,
					docUrl: null,
					docTypeId: null,
					docSubtypeId: null,
					index: 1,
				},
			],
			socialMedia: [
				{
					name: null,
					url: null,
					index: 1,
				},
			],
		},
		requiredFields: {
			name: false,
			corporate_name: false,
			cnpj: false,
			shortDescription: false,
			statusId: false,
			industryTypeId: false,
			videoUrl: false,
			headOfficeLocation: false,
			site: false,
			foundationDate: false,
			totalValueOffer: false,
			deadlineLastEmissions: false,
			remunerationLastEmissions: false,
			numberEmissions: false,
			hasFullWallet: false,
			defaultWallet: false,
		},
		newOriginator: false,
		isEditing: false,
		showDeleteModal: false,
		imgSrc: null,
		fileName: null,
		file: null,
		socialMediaOptions: [
			{
				id: 1,
				name: 'Facebook',
			},
			{
				id: 2,
				name: 'Instagram',
			},
			{
				id: 3,
				name: 'Linkedin',
			},
			{
				id: 4,
				name: 'Twitter',
			},
			{
				id: 5,
				name: 'Youtube',
			},
		],
		dashboardsTabs: [
			{
				id: 'highlights',
				label: 'Destaques',
				checked: true,
			},
			{
				id: 'wallet',
				label: 'Carteira',
				checked: true,
			},
			{
				id: 'production',
				label: 'Produção',
				checked: true,
			},
			{
				id: 'concentration',
				label: 'Concentração',
				checked: true,
			},
			{
				id: 'inadimplency',
				label: 'Inadimplência',
				checked: true,
			},
			{
				id: 'cancellation',
				label: 'Cancelamento',
				checked: true,
			},
			{
				id: 'specific',
				label: 'Específicos',
				checked: true,
			},
		],
		selectedSocialMedia: [],
		currentSocialMediaOptions: [],
		addSocials: 2,
	}),
	created() {
		this.getOriginators({ vm: this });
		this.getIndustries({ vm: this });
		this.getDocTypes({ vm: this });
		this.getDocSubtypes({ vm: this });
	},
	mounted() {
		this.currentSocialMediaOptions = this.socialMediaOptions;

		if (this.$route.query.id) {
			this.getOriginator({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedOriginator = res.data;

				this.originator.foundationDate = this.$moment(
					selectedOriginator.foundationDate,
					'YYYY-MM',
				).format('MM/YYYY');

				this.originator.name = selectedOriginator.name;
				this.originator.corporate_name = selectedOriginator.corporate_name;
				this.originator.cnpj = selectedOriginator.cnpj;
				this.originator.description = selectedOriginator.description;
				this.originator.shortDescription = selectedOriginator.shortDescription;
				this.imgSrc = selectedOriginator.logo_url;
				this.originator.statusId = selectedOriginator.originatorStatus.id;
				this.originator.videoType = selectedOriginator.videoType;
				this.$refs.status.setValue(selectedOriginator.originatorStatus);
				if (selectedOriginator.industryType != null) {
					this.originator.industryTypeId = selectedOriginator.industryType.id;
				}

				if (selectedOriginator.defaultWallet.length > 0) {
					const offer = this.walletOptions?.find(
						(offer) => offer.id === selectedOriginator.defaultWallet,
					);
					this.$nextTick(() => {
						this.$refs.defaultWallet.setValue(offer);
					});
					this.originator.defaultWallet = selectedOriginator.defaultWallet;
				}

				const WalletOption = this.hasFullWalletOptions.find(
					(option) => option.id === selectedOriginator.hasFullWallet,
				);
				this.$refs.industry.setValue(selectedOriginator.industryType);
				this.originator.hasFullWallet = WalletOption.id;
				this.originator.videoUrl = selectedOriginator.videoUrl;
				this.originator.headOfficeLocation = selectedOriginator.headOfficeLocation;
				this.originator.site = selectedOriginator.site;
				this.originator.deadlineLastEmissions = selectedOriginator.deadlineLastEmissions;
				this.originator.remunerationLastEmissions = selectedOriginator.remunerationLastEmissions;
				this.originator.numberEmissions = selectedOriginator.numberEmissions;
				this.originator.site = selectedOriginator.site;

				if (selectedOriginator.originatorDashboardPages.length) {
					this.dashboardsTabs.forEach((element) => {
						if (!selectedOriginator.originatorDashboardPages.includes(element.id)) {
							element.checked = false;
						}
					});
				} else {
					this.dashboardsTabs.forEach((element) => {
						element.checked = false;
					});
				}

				if (selectedOriginator.videoType == 'youtube') {
					this.$refs.video_type.setValue(this.videoOptions[0]);
				} else if (selectedOriginator.videoType == 'vimeo') {
					this.$refs.video_type.setValue(this.videoOptions[1]);
				}

				this.$refs.value_total.setMoneyValue(
					selectedOriginator.totalValueOffer == null ? 0 : selectedOriginator.totalValueOffer,
				);
				this.originator.totalValueOffer = selectedOriginator.totalValueOffer;

				if (selectedOriginator.documents.length) {
					this.originator.originatorDocs = [];

					selectedOriginator.documents.forEach((doc, index) => {
						doc.index = index + 1;

						this.originator.originatorDocs.push(doc);

						setTimeout(() => {
							const splitedDocName = doc.docUrl.split('/');

							this.$refs[`doc_type_${index + 1}`][0].setValue(doc.docType);
							this.$refs[`doc_subtype_${index + 1}`][0].setValue(doc.docSubtype);
							this.$refs[`docs_file_${index + 1}`][0].setFileName(
								splitedDocName[splitedDocName.length - 1],
							);
						}, 500);
					});
				}

				if (selectedOriginator.socialMedia.length) {
					this.originator.socialMedia = [];

					selectedOriginator.socialMedia.forEach((social, index) => {
						social.index = index + 1;
						this.originator.socialMedia.push(social);

						setTimeout(() => {
							if (social.name == 'Facebook') {
								this.$refs[`social_media_${index + 1}`][0].setValue(this.socialMediaOptions[0]);
							}
							if (social.name == 'Instagram') {
								this.$refs[`social_media_${index + 1}`][0].setValue(this.socialMediaOptions[1]);
							}
							if (social.name == 'Linkedin') {
								this.$refs[`social_media_${index + 1}`][0].setValue(this.socialMediaOptions[2]);
							}
							if (social.name == 'Twitter') {
								this.$refs[`social_media_${index + 1}`][0].setValue(this.socialMediaOptions[3]);
							}
							if (social.name == 'Youtube') {
								this.$refs[`social_media_${index + 1}`][0].setValue(this.socialMediaOptions[4]);
							}
						}, 500);
					});
				}

				if (selectedOriginator.advertisingMaterialUrl) {
					const splitedPresentationName = selectedOriginator.advertisingMaterialUrl.split('/');

					this.$refs.advertising_material.setFileName(
						splitedPresentationName[splitedPresentationName.length - 1],
					);
				}
			});

			this.isEditing = true;
		} else {
			this.newOriginator = true;
		}
	},
	methods: {
		...mapActions('originatorManagement', {
			getOriginator: GET_ORIGINATOR_BY_ID,
			createNewOriginator: CREATE_ORIGINATOR,
			updateOriginator: UPDATE_ORIGINATOR,
			deleteOriginator: DELETE_ORIGINATOR,
			getIndustries: GET_ALL_INDUSTRY,
			getDocTypes: GET_ALL_DOC_TYPE,
			getDocSubtypes: GET_ALL_DOC_SUBTYPE,
		}),
		...mapActions('offerManagement', {
			getOriginators: GET_ALL_ORIGINATORS,
		}),
		setDefaultWallet(param) {
			if (param) {
				const defaultWallet = {
					id: '00000000-0000-0000-0000-000000000001',
					name: 'Carteira Completa',
				};
				this.originator.hasFullWallet = true;
				this.originator.defaultWallet = defaultWallet.id;
				this.$nextTick(() => {
					this.$refs.hasFullWallet.setValue(this.hasFullWalletOptions[0]);
					this.$refs.defaultWallet.setValue(defaultWallet);
				});
			} else {
				this.originator.hasFullWallet = false;
				this.originator.defaultWallet = this.walletOptions[0].id;
				this.$nextTick(() => {
					this.$refs.hasFullWallet.setValue(this.hasFullWalletOptions[1]);
					this.$refs.defaultWallet.setValue(this.walletOptions[0]);
				});
			}
		},
		validateCNPJ(cnpj) {
			cnpj = cnpj.replace(/[^\d]+/g, '');

			// Elimina CNPJs invalidos conhecidos
			if (
				cnpj == '00000000000000' ||
				cnpj == '11111111111111' ||
				cnpj == '22222222222222' ||
				cnpj == '33333333333333' ||
				cnpj == '44444444444444' ||
				cnpj == '55555555555555' ||
				cnpj == '66666666666666' ||
				cnpj == '77777777777777' ||
				cnpj == '88888888888888' ||
				cnpj == '99999999999999'
			)
				return false;

			// Valida DVs
			let tamanho = cnpj.length - 2;
			let numeros = cnpj.substring(0, tamanho);
			let digitos = cnpj.substring(tamanho);
			let soma = 0;
			let pos = tamanho - 7;
			for (let i = tamanho; i >= 1; i--) {
				soma += numeros.charAt(tamanho - i) * pos--;
				if (pos < 2) pos = 9;
			}

			let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
			if (resultado != digitos.charAt(0)) return false;

			tamanho = tamanho + 1;
			numeros = cnpj.substring(0, tamanho);
			soma = 0;
			pos = tamanho - 7;

			for (let i = tamanho; i >= 1; i--) {
				soma += numeros.charAt(tamanho - i) * pos--;
				if (pos < 2) pos = 9;
			}

			resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

			if (resultado != digitos.charAt(1)) return false;

			return true;
		},
		goToCreateOffer() {
			this.$router.push({
				path: '/dashboard/offer/detail',
				query: { originator: this.$route.query.id },
			});
		},
		changeStatusInput(param) {
			this.originator.statusId = param.value?.id;
		},
		changeIndustryInput(param) {
			this.originator.industryTypeId = param.value?.id;
		},
		changeVideoInput(param) {
			this.originator.videoType = param.value?.id;
		},
		changeDefaultWallet(param) {
			this.originator.defaultWallet = param.value?.id;
		},
		changeHasFullWallet(param) {
			this.originator.hasFullWallet = param.value?.id;
			this.validateFullWallet(this.originator.hasFullWallet);
			this.setDefaultWallet(this.originator.hasFullWallet);
		},
		validateFullWallet(hasFullWallet) {
			const isNewOriginator = !this.isEditing;
			if (hasFullWallet && isNewOriginator) {
				const fullWallet = this.walletOptions[0];
				this.originator.defaultWallet = fullWallet.id;
				this.$nextTick(() => {
					this.$refs.defaultWallet.setValue(fullWallet);
				});
			}
		},
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		onFileChange(e) {
			this.imgSrc = null;

			if (e == null) {
				this.fileName = null;
				this.originator.logoFile = null;
				this.file = null;
			} else {
				const file = e.target.files[0];
				const sanitizedFileName = removeSpecialChars(file.name);
				this.file = copyAndRenameFile(file, sanitizedFileName);
				this.fileName = sanitizedFileName;
				this.originator.logoFile = sanitizedFileName;

				if (file.type.indexOf('image/') === 0) {
					const reader = new FileReader();

					reader.onload = (event) => {
						this.imgSrc = event.target.result;
					};

					reader.readAsDataURL(file);
					return;
				}
			}
		},
		confirmDelete() {
			this.deleteOriginator({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/originators' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		async createOriginator() {
			const formData = new FormData();

			let newOriginator = JSON.stringify(this.originator);
			newOriginator = JSON.parse(newOriginator);

			let foundationDate = newOriginator.foundationDate
				? this.$moment('01/' + newOriginator.foundationDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
				: null;

			const checkedTabs = this.dashboardsTabs.filter((item) => item.checked).map((item) => item.id);

			const body = {
				name: this.originator.name,
				corporate_name: this.originator.corporate_name,
				cnpj: this.originator.cnpj,
				description: this.originator.description,
				shortDescription: this.originator.shortDescription,
				statusId: this.originator.statusId,
				videoUrl: this.originator.videoUrl,
				videoType: this.originator.videoType,
				foundationDate: foundationDate,
				headOfficeLocation: this.originator.headOfficeLocation,
				site: this.originator.site,
				industryTypeId: this.originator.industryTypeId,
				socialMedia: [],
				originatorDashboardPages: checkedTabs,
				documents: [],
				logoFile: this.originator.logoFile || undefined,
				hasFullWallet: false,
			};

			if (newOriginator.originatorDocs.length && !this.isEditing) {
				newOriginator.originatorDocs = newOriginator.originatorDocs.filter(
					(docs) =>
						docs.name != null ||
						docs.docUrl != null ||
						docs.docTypeId != null ||
						docs.docSubtypeId != null,
				);

				newOriginator.originatorDocs.forEach((doc) => {
					const docFile = this.$refs[`docs_file_${doc.index}`][0].getFile();
					const sanitizedDocName = removeSpecialChars(docFile.name);

					if (docFile != null)
						formData.append('file', copyAndRenameFile(docFile, sanitizedDocName));

					delete doc.index;

					body.documents.push({
						name: doc.name,
						docUrl: removeSpecialChars(doc.docUrl),
						docTypeId: doc.docTypeId,
						docSubtypeId: doc.docSubtypeId,
					});
				});
			}

			if (newOriginator.socialMedia.length && !this.isEditing) {
				newOriginator.socialMedia = newOriginator.socialMedia.filter(
					(social) => social.name != null || social.url != null,
				);

				newOriginator.socialMedia.forEach((social) => {
					body.socialMedia.push({
						name: social.name,
						url: social.url,
					});
				});
			}

			if (newOriginator.advertisingMaterialUrl) {
				const presentationFile = this.$refs.advertising_material.getFile();

				if (presentationFile != null) {
					const sanitizedFileName = removeSpecialChars(
						this.$refs.advertising_material.getFileName(),
					);
					formData.append('file', copyAndRenameFile(presentationFile, sanitizedFileName));
					body['advertisingMaterialUrl'] = sanitizedFileName;
				}
			}

			formData.append('data', JSON.stringify(body));
			if (this.file) formData.append('file', this.file);

			const res = await this.createNewOriginator({ vm: this, body: formData });
			if (res.status == 201) {
				this.$router.push({ path: '/dashboard/originators' });
			}
		},
		async confirmUpdate() {
			const formData = new FormData();

			let newOriginator = JSON.stringify(this.originator);
			newOriginator = JSON.parse(newOriginator);

			let foundationDate = this.$moment('01/' + newOriginator.foundationDate, 'DD/MM/YYYY').format(
				'YYYY-MM-DD',
			);

			const checkedTabs = this.dashboardsTabs.filter((item) => item.checked).map((item) => item.id);

			const body = {
				name: this.originator.name,
				corporate_name: this.originator.corporate_name,
				cnpj: this.originator.cnpj,
				description: this.originator.description,
				shortDescription: this.originator.shortDescription,
				statusId: this.originator.statusId,
				videoUrl: this.originator.videoUrl,
				videoType: this.originator.videoType,
				foundationDate: foundationDate,
				headOfficeLocation: this.originator.headOfficeLocation,
				site: this.originator.site,
				industryTypeId: this.originator.industryTypeId,
				documents: [],
				socialMedia: [],
				originatorDashboardPages: checkedTabs,
				logoFile: this.originator.logoFile || undefined,
				hasFullWallet: false,
				defaultWallet: this.originator.defaultWallet,
			};

			if (newOriginator.originatorDocs.length) {
				newOriginator.originatorDocs.forEach((docs, index) => {
					const docFile = this.$refs[`docs_file_${index + 1}`][0].getFile();

					if (docFile != null) {
						delete docs.index;
						if (docs.id) delete docs.id;
						const sanitizedDocName = removeSpecialChars(docFile.name);
						const newFile = copyAndRenameFile(docFile, sanitizedDocName);
						docs['docUrl'] = sanitizedDocName;
						return formData.append('file', newFile);
					}

					docs['docTypeId'] = docs.docType ? docs.docType.id : docs.docTypeId;
					docs['docSubtypeId'] = docs.docSubtype ? docs.docSubtype.id : docs.docSubtypeId;

					delete docs.createdAt;
					delete docs.deletedAt;
					delete docs.docSubtype;
					delete docs.docType;
					delete docs.index;
				});

				newOriginator.originatorDocs = newOriginator.originatorDocs.filter(
					(docs) =>
						docs.name != null ||
						docs.docUrl != null ||
						docs.docTypeId != null ||
						docs.docSubtypeId != null,
				);

				body.documents = newOriginator.originatorDocs;
			}

			if (newOriginator.socialMedia.length) {
				newOriginator.socialMedia.forEach((social) => {
					delete social.createdAt;
					delete social.deletedAt;
					delete social.index;
				});

				newOriginator.socialMedia = newOriginator.socialMedia.filter(
					(docs) => docs.name != null || docs.url != null,
				);
				body.socialMedia = newOriginator.socialMedia;
			}

			if (newOriginator.advertisingMaterialUrl) {
				const presentationFile = this.$refs.advertising_material.getFile();

				if (presentationFile != null) {
					const sanitizedFileName = removeSpecialChars(presentationFile.name);
					formData.append('file', copyAndRenameFile(presentationFile, sanitizedFileName));
					body['advertisingMaterialUrl'] = sanitizedFileName;
				}
			}

			if (this.file) formData.append('file', this.file);
			formData.append('data', JSON.stringify(body));

			await this.updateOriginator({ vm: this, id: this.$route.query.id, body: formData });
		},
		addNewDocs() {
			this.requiredFields.originatorDocs = false;

			this.originator.originatorDocs.push({
				name: null,
				docUrl: null,
				docTypeId: null,
				docSubtypeId: null,
				index: this.originator.originatorDocs.length + 1,
			});
		},
		addNewSocialMedia() {
			this.originator.socialMedia.push({
				name: null,
				url: null,
				index: this.originator.socialMedia.length + 1,
			});

			this.addSocials++;
		},
		changeTypeInput(param) {
			const typeIndex = param.type.split('_')[2];
			this.originator.originatorDocs[typeIndex - 1].docTypeId = param.value?.id;
		},
		changeSubtypeInput(param) {
			const subtypeIndex = param.type.split('_')[2];
			this.originator.originatorDocs[subtypeIndex - 1].docSubtypeId = param.value?.id;
		},
		removeDocs(param) {
			this.originator.originatorDocs = this.originator.originatorDocs.filter(
				(doc) => doc.index != param.index,
			);
		},
		changeSocialMediaInput(param) {
			let cachedArray = [];
			this.selectedSocialMedia.push(param.value.name);

			this.filteredSocialMediaOptions(param);

			let selectValueByRef = this.$refs[param.type][0].getValue();

			this.currentSocialMediaOptions = this.socialMediaOptions.filter(
				(item) => item.name != selectValueByRef.name,
			);

			this.selectedSocialMedia = [...new Set(this.selectedSocialMedia)];

			if (this.$refs['social_media_1']) {
				cachedArray.push(this.$refs['social_media_1'][0].getValue());
			}
			if (this.$refs['social_media_2']) {
				cachedArray.push(this.$refs['social_media_2'][0].getValue());
			}
			if (this.$refs['social_media_3']) {
				cachedArray.push(this.$refs['social_media_3'][0].getValue());
			}
			if (this.$refs['social_media_4']) {
				cachedArray.push(this.$refs['social_media_4'][0].getValue());
			}
			if (this.$refs['social_media_5']) {
				cachedArray.push(this.$refs['social_media_5'][0].getValue());
			}

			cachedArray = cachedArray.filter((item) => item != null);
			cachedArray = cachedArray.map((item) => item.name);
			cachedArray = [...new Set(cachedArray)];

			this.currentSocialMediaOptions = this.currentSocialMediaOptions.filter(
				(item) => !cachedArray.includes(item.name),
			);

			const socialMediaIndex = param.type.split('_')[2];
			this.originator.socialMedia[socialMediaIndex - 1].name = param.value.name;
		},
		changeSocialMediaInputUrl(param) {
			const socialMediaIndex = param.type.split('_')[2];
			this.originator.socialMedia[socialMediaIndex - 1].url = param.value.url;
		},
		removeSocialMedia(param) {
			this.originator.socialMedia = this.originator.socialMedia.filter(
				(doc) => doc.index != param.index,
			);
			this.selectedSocialMedia = this.selectedSocialMedia.filter(
				(element) => element != param.name,
			);
			if (param.value != null) {
				const deletedSocialMedia = this.socialMediaOptions.filter(
					(item) => item.name == param.name,
				);

				this.currentSocialMediaOptions.push(deletedSocialMedia[0]);
				this.currentSocialMediaOptions = this.currentSocialMediaOptions.sort((a, b) => a.id - b.id);
			}

			this.filteredSocialMediaOptions(param);
			this.addSocials--;
		},
		async validateFields() {
			let ref;
			this.requiredFields = {
				name: false,
				statusId: false,
				industryTypeId: false,
			};

			if (!this.originator.industryTypeId) {
				this.requiredFields.industryTypeId = true;
				ref = 'industryRequired';
			}

			if (!this.originator.statusId) {
				this.requiredFields.statusId = true;
				ref = 'statusRequired';
			}

			if (!this.originator.name) {
				this.requiredFields.name = true;
				ref = 'nameRequired';
			}

			if (this.originator.hasFullWallet && this.defaultWalletIsNotValid()) {
				this.requiredFields.defaultWallet = true;
				ref = 'defaultWalletRequired';
			} else if (this.originator.hasFullWallet === false) {
				this.requiredFields.defaultWallet = false;
			}

			if (
				!this.originator.name ||
				!this.originator.statusId ||
				!this.originator.industryTypeId
			) {
				scrollToRequiredElement(this, ref);

				return;
			}

			if (this.originator.cnpj && !this.validateCNPJ(this.originator.cnpj)) {
				return this.$toastr.e('CNPJ inválido.');
			}

			if (!this.newOriginator) {
				await this.confirmUpdate();
			} else {
				await this.createOriginator();
			}
		},
		hasFullWalletIsNotValid() {
			return this.originator.hasFullWallet === null || this.originator.hasFullWallet === undefined;
		},
		defaultWalletIsNotValid() {
			return this.originator.defaultWallet === null || this.originator.defaultWallet === undefined;
		},
		filteredSocialMediaOptions(param) {
			const selectedSocialMediaOptions = this.selectedSocialMedia;

			this.currentSocialMediaOptions = this.socialMediaOptions.filter((item) => {
				if (!selectedSocialMediaOptions.find((element) => element == item.name)) {
					return item;
				}
			});
		},
		clearAdvertising() {
			this.originator.advertisingMaterialUrl = null;
		},
	},
	computed: {
		...mapGetters('originatorManagement', [
			'originatorStatusList',
			'originatorIndustryList',
			'originatorDocTypes',
			'originatorDocSubtypes',
			'isLoadingOriginators',
			'originatorOffersList',
			'isLoadingOriginatorOffers',
		]),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
		statusOptions() {
			const status = this.originatorStatusList.length ? this.originatorStatusList : [];

			return status;
		},
		industriesOptions() {
			const industry =
				this.originatorIndustryList &&
				this.originatorIndustryList.industryTypes != undefined &&
				this.originatorIndustryList.industryTypes.length
					? this.originatorIndustryList.industryTypes
					: [];

			return industry;
		},
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
		docTypeOptions() {
			const docTypes = this.originatorDocTypes.docTypes?.length
				? this.originatorDocTypes.docTypes
				: [];

			return docTypes;
		},
		docSubtypeOptions() {
			const docSubtypes = this.originatorDocSubtypes.docSubtypes?.length
				? this.originatorDocSubtypes.docSubtypes
				: [];

			return docSubtypes;
		},
		videoOptions() {
			return [
				{
					id: 'youtube',
					name: 'YouTube',
				},
				{
					id: 'vimeo',
					name: 'Vimeo',
				},
			];
		},
		walletOptions() {
			const isNewOriginator = !this.isEditing;
			const fullWalletList = [];

			if (isNewOriginator) {
				return fullWalletList;
			} else {
				if (this.isLoadingOriginatorOffers) {
					return [];
				} else {
					this.originatorOffersList.offers
						// ?.filter((offer) => offer.offerStatus.id === OfferStatusEnum.FINISHED):
						.forEach((offer) => {
							const offerItem = {
								id: offer.id,
								name: offer.shortDescription,
							};
							fullWalletList.push(offerItem);
						});
					if (this.originator.hasFullWallet) {
						const fullWallet = {
							id: '00000000-0000-0000-0000-000000000001',
							name: 'Carteira Completa',
						};

						fullWalletList.push(fullWallet);
					}

					return fullWalletList;
				}
			}
		},
		hasFullWalletOptions() {
			return [
				{
					id: false,
					name: 'Não',
				},
				{
					id: false,
					name: 'Não',
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OriginatorForm.scss';
</style>
